/**
 * Centralized checkout destination.
 * Hotmart checkout destination — all purchase CTAs redirect here.
 */
export const HOTMART_CHECKOUT_URL = "https://pay.hotmart.com/I106061654O?checkoutMode=10";

export function goToCheckout() {
  if (typeof window !== "undefined") {
    window.location.href = HOTMART_CHECKOUT_URL;
  }
}
